
import { computed, defineComponent } from "vue";
import router from "../../router";
import gameApplication from "../../game/game-app";
import { GameStage } from "../../types/game-stage-enum";
import { useStore } from "../../stores";
import { LoggedOutPlayer } from "../../protocol/dto/logged-out-player";
import { ActionTypes } from "../../stores/action-types";
import AppConfig from "@/config/app-config";

export default defineComponent({
  name: "DropdownMenu",

  data: () => ({
    show: false,
    addresses: [],
  }),

  mounted() {
  },

  setup() { 
    const gameKind = computed(() => gameApplication.getGameKind());
    return { gameKind };
  },

  methods: {
    onNewGame(): void {
      gameApplication.startPractice();
    },

    onLeaveGame(): void {
       // stop the game aminiation
      if (gameApplication.requestId !== undefined) {
        gameApplication.stopAnimate();
      }

      if (gameApplication.getGameKind() === 'PRACTICE') {
        this.onExitRoom();
      } else {
        if (gameApplication.getGameStage() === GameStage.GameInProgress) {
          gameApplication.sendLeaveGameMessage();
        } else {
          this.onExitRoom();
        }
      }
    },

    onExitRoom(): void {
      const store = useStore();

      // stop the game aminiation
      if (gameApplication.requestId !== undefined) {
        gameApplication.stopAnimate();
      }

      if (gameApplication.getGameKind() === 'PRACTICE') {
        store.state.isRoomsShown = false;
      } else {
        store.state.isRoomsShown = true;
      }

      if (gameApplication.getGameKind() !== 'PRACTICE') {
        if (gameApplication.getGameStage() === GameStage.GameInProgress) {
          gameApplication.sendLeaveGameMessage();
        }
      } 
      
      gameApplication.setGameStage(GameStage.RoomChoosing);

      gameApplication.leaveRoom();
      gameApplication.setGameKind(undefined);
      store.state.selectedRoomId = null;

      // After all the processing is done change the path lastly.
      // This is because if the processing is not done first it will be done 
      // again in the router class.
      router.push({ path: '/' });
    },

    logout(): void {
      const store = useStore();
      const user: LoggedOutPlayer = {
        username: gameApplication.getPlayer().playerId,      
      };

      // stop the game animation
      if (gameApplication.requestId !== undefined) {
        gameApplication.stopAnimate();
      }
      
      store.state.isLoginShown = true;
      store.dispatch(ActionTypes.USER_LOGOUT, user);
      
      // After all the processing is done change the path lastly.
      // This is because if the processing is not done first it will be done 
      // again in the router class.
      window.location.href = AppConfig.WEB_SITE_PLAY_PAGE;
    },

    openDonate(): void {
      gameApplication.fireEvent('OPEN_DONATE');
    },

    openHelp(): void {
      gameApplication.fireEvent('OPEN_HELP');
    },

    openSettings(): void {
      gameApplication.fireEvent('OPEN_SETTINGS');
    }
   },
});
